import Vue from 'vue'
import Router from 'vue-router'
import CampaignDetail from '@/components/campaign-detail/CampaignDetail.vue'
import ProductList from '@/components/product/ProductList.vue'
import DspTagList from '@/components/dsp-tags/DspTagList.vue'
import DspAdvertiser from '@/components/dsp-tags/DspAdvertiser.vue'
import AddEditProduct from '@/components/add-product/AddEditProduct.vue'
import AddCampaign from '@/components/add-campaign/AddCampaign.vue'
import CampaignList from '@/components/campaign-list/CampaignList.vue'
import AddToCampaignList from '@/components/campaign/CampaignListAdd.vue'
import SignInForm from '@/components/user/SignInForm'
import CampaignGroup from '@/components/campaign-group/CampaignGroup'
import NotificationList from '@/components/notification/NotificationList.vue'
import AsinScraperList from '@/components/asin-scraper/AsinScraperList.vue'
import EditCampaign from '@/components/campaign-group/EditCampaignGroupModal.vue'
// import Login from '@/components/login/Login.vue'
import LoginContainer from '@/components/NewLogin/LoginContainer.vue'
import Automation2 from '@/components/Automation2/Automation2.vue'
import KeywordDetail from '@/components/keyword/KeywordDetail.vue'
import Activity from '@/components/Activity/Activity.vue'
import RecommendKeyword from '@/components/keyword/RecommendKeyword.vue'
import AccountList from '@/components/account-management/AccountList.vue'
import AddVendor from '@/components/account-management/AddVendor.vue'
import AsinScraperAddForm from '@/components/asin-scraper/AsinScraperAddForm.vue'
import SalesList from '@/components/sales-diagnostic/SalesList.vue'
import AccountDetails from '@/components/account-management/AccountDetails.vue'
import ReleaseNotes from '@/components/release-notes/ReleaseNotes.vue'
import AddReleaseNote from '@/components/release-notes/AddReleaseNote.vue'
import Detail from '@/components/release-notes/Detail.vue'
import Template from '@/components/templates/Template.vue'
import AddEditTemplate from '@/components/templates/AddEditTemplate.vue'
import AddGuardrail from '@/components/define-guardrail/AddToGuardrail.vue'
import Mapping from '@/components/mapping/Mapping.vue'
import TableauRecord2 from '@/components/tableau-chart/TableauRecord2.vue'
import TableauRecord3 from '@/components/tableau-chart/TableauRecord3.vue'
import AddEditGuardrail from '@/components/add-guardrail/AddEditGuardrail.vue'

Vue.use(Router)

const router = new Router({
	base: process.env.BASE_URL,
	routes: [
		{
			path:'/',
			name:'tableau3',
			component: TableauRecord3
		},
		// {
		// 	path: '/',
		// 	name: 'campaignList',
		// 	component: CampaignList
		// },
		{
			path: '/editCampaign/:campaignId',
			name: 'editCampaign',
			component: EditCampaign
		},
		{
			path: '/addCampaign',
			name: 'addCampaign',
			component: EditCampaign
		},
		{
			path: '/productList',
			name: 'productList',
			component: ProductList
		},
		{
			path: '/dspTagList',
			name: 'dspTagList',
			component: DspTagList
		},
		{
			path: '/dspAdvertiser/:orderId',
			name: 'dspAdvertiser',
			component: DspAdvertiser
		},
		{
			path: '/addEditProduct',
			name: 'addEditProduct',
			component: AddEditProduct
		},
		{
			path: '/addEditProduct/:productId',
			name: 'addNewProduct',
			component: AddEditProduct
		},
		{
			path: '/addEditGuardrail/:guardrailId/:type/:calledFrom?',
			name: 'addEditGuardrail',
			component: AddEditGuardrail
		},
		{
			path: '/addEditCampaign/:campaignId/:groupId?',
			name: 'addEditCampaign',
			component: AddCampaign
		},
		{
			path: '/addEditCampaignProduct/:products',
			name: 'addNewCampaign',
			component: AddCampaign
		},
		{
			path: '/addEditCampaign',
			name: 'addNewCampaign',
			component: AddCampaign
		},
		{
			path: '/campaignList',
			name: 'campaignList',
			component: CampaignList,
			props: true
		},
		{
			path: '/campaignList/:groupId',
			name: 'campaignListPerGroup',
			component: CampaignList
		},
		{
			path: '/addToCampaign/:products/:vendorId?/:brandId?/:productTitle',
			name: 'addToCampaign',
			component: AddToCampaignList
		},
		{
			path: '/campaignGroupList',
			name: 'campaignGroupList',
			component: CampaignGroup
		},
		{
			path:'/automation2',
			name: 'Automation2',
			component: Automation2
		},
		{
			path:'/myAutomation',
			name:'MyAutomation',
			component:Automation2	
		},
		{
			path:'/notification',
			// beforeEnter(to,from,next){
			// 	window.location="https://goads.123goecom.com/alert.html"
			// }
			name: 'notification',
			component: NotificationList
		},
		{
			path:'/asinScraper',
			name: 'asinScraper',
			component: AsinScraperList
		},
		{
			path: '/CampaignDetail/:campaignId/:campaignName',
			name: 'CampaignDetail',
			component: CampaignDetail
		},
		{
			path:'/login',
			name: 'login',
			component: LoginContainer,
		},
		{
			path:'/KeywordDetail/:campaignId/:amsCampaignId/:sponsoredType/:campName/:campBudget',
			name:'KeywordDetail',
			component: KeywordDetail,
		},
		{
			path:'/activityList/campaignGroup/:campGrpId/:campGrpName',
			name:'activityList',
			component: Activity
		},
		{
			path:'/activityList/campaign/:campId/:campName',
			name:'activityList',
			component: Activity
		},
		{
			path:'/recommendKeyword/:campId/:amsCampId/:amsProfileId/:campaignType/:campName/:type',
			name:'recommendKeyword',
			component: RecommendKeyword
		},
		{
			path:'/accounts',
			name:'accounts',
			component: AccountList
		},
		{
			path:'/addVendor',
			name:'addVendor',
			component: AddVendor
		},
		{
			path:'/addVendor/:ProfileId',
			name:'addVendor',
			component: AddVendor
		},
		{
			path:'/editBrand/:BrandProfileId/:profile',
			name:'editBrand',
			component: AddVendor
		},
		{
			path:'/asinScraperAddForm',
			name:'asinScraperAddForm',
			component: AsinScraperAddForm
		},
		{
			path:'/salesList',
			name:'salesList',
			component: SalesList
		},
		{
			// path:'/accountDetails/:clientId/:ProfileBrandName/:profile_id/:vendorId',
			path:'/accountDetails/:clientId/:clientName',
			name:'accountDetails',
			component: AccountDetails
		},
		{
			path:'/accountDetails/profile/:profileId/:ProfileBrandName/:profile_id/:vendorId',
			name:'/accountDetails/profile',
			component: AccountDetails
		},
		{
			path:'/releaseNotes',
			name:'releaseNotes',
			component: ReleaseNotes
		},
		{
			path:'/addNote/:id',
			name:'addNote',
			component: AddReleaseNote
		},
		{
			path:'/addNote',
			name:'addNote',
			component: AddReleaseNote
		},
		{
			path:'/releaseDetail/:id',
			name:'releaseDetail',
			component: Detail
		},
		{
			path:'/releaseDetail/detail/:id',
			name:'releaseDetail/detail',
			component: Detail
		},
		{
			path:'/template',
			name:'template',
			component: Template
		},
		{
			path:'/addTemplate',
			name:'addTemplate',
			component: AddEditTemplate
		},
		{
			path:'/editTemplate/:id',
			name:'editTemplate',
			component: AddEditTemplate
		},
		{
			path:'/AddGuardrail/:type',
			name:'addGuardrail',
			component: AddGuardrail
		},
		{
			path:'/mapping',
			name:'mapping',
			component: Mapping
		},
		{
			path:'/tableau',
			name:'tableau',
			component: TableauRecord3
		},
		{
			path:'/tableau2',
			name:'tableau2',
			component: TableauRecord2
		},
		{
			path:'/tableau3',
			name:'tableau3',
			component: TableauRecord3

		}
	]
})

router.beforeEach((to, from, next) => {
	let email = '';
	let idToken = '';
	let tempEmail = '';
	let tempIdToken = '';
	if(window.localStorage && window.localStorage.session){
		let session = JSON.parse(window.localStorage.session)
		if(session){
			email = session.name;
			idToken = session.idToken
		}
	}
	if(window.sessionStorage && window.sessionStorage.session){
		let session = JSON.parse(window.sessionStorage.session)
		if(session){
			tempEmail = session.name;
			tempIdToken = session.idToken
		}
	}
	if(!email && !idToken && !to.fullPath.includes('/login')){
		let prev_route = to;
		console.log(to);
		localStorage.setItem("release:releasepath", to.fullPath);
		if(prev_route.query){
			next({path:'/login',query:prev_route.query})
		}
		else{
			next({ path: '/login' });
		}		
	}
	else if(to.fullPath =='/'){
		next({path:'/accounts'});
	}
	else{
		next();
	}
	$('.go-popover') ? $('.go-popover').popover('hide') : '';
})

export default router
